import appApi from '../../../../../../api/app-api';
import { WorkingHoursStatus } from '../../../../../../api/types/lecturers/working-hours/working-hours.type';
import { toast } from 'react-toastify';

export const updateWorkingHoursStatusOperation = async (
  workingHoursId: number,
  workingHoursStatus: WorkingHoursStatus,
): Promise<boolean> => {
  try {
    await appApi.updateManualWorkingHoursStatus(
      workingHoursId,
      workingHoursStatus,
    );
    return true;
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים...');
    console.error(
      `updateWorkingHoursStatusOperation is failed with the workingHoursId: ${workingHoursId}, workingHoursStatus: ${workingHoursStatus} and the error: ${e}`,
    );
    return false;
  }
};
